<template>
  <div class="hello">
    <h2>关于第三方SDK的说明</h2>
    <p>
      为了适配在不同手机设备上的使用以及第三方平台服务，实现您的手机设备身份认证、手机设备安全、接收信息推送、登录第三方平台账号、通过第三方平台分享信息以及支付安全，由此接入了第三方SDK。
    </p>
    <p>所接入的部分第三方SDK会调用您的设备部分权限、获取您的相关信息，以便您在不同的手机设备或第三方平台上正常使用相应功能，我们将这些具有个人信息收集功能的第三方SDK的名称、所提供的功能/服务、隐私政策链接、申请调用的权限及收集个人信息类型，按照实现功能/服务的类别划分列明如下：</p>
    <div>
      <table border="1" class="tab">
        <thead>
          <tr>
            <th>SDK 名称</th>
            <th>公司名称</th>
            <th>收集目的</th>
            <th>收集方式</th>
            <th>收集范围</th>
            <th>隐私政策</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ele, index) in commonInfo">
            <td>{{ ele.name }}</td>
            <td>{{ ele.company }}</td>
            <td>{{ ele.goal }}</td>
            <td>{{ ele.type }}</td>
            <td>{{ ele.range }}</td>
            <td class="link">
              <a :href="ele.link">{{ ele.link }}</a>
            </td>
          </tr>
           <tr v-if="!isIOS" v-for="(data, index) in isAndroidInfo">
                <td>{{ data.name }}</td>
                  <td>{{ data.company }}</td>
                  <td>{{ data.goal }}</td>
                  <td>{{ data.type }}</td>
                  <td>{{ data.range }}</td>
                  <td class="link">
                    <a :href="data.link">{{ data.link }}</a>
                  </td>
              </tr>
        </tbody>
      </table>
       <p class="warn">
        请注意，第三方 SDK
        可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，具体请以其公示的官方说明为准。
      </p>
    </div>
  </div>
</template>

<script>
let u = navigator.userAgent
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //安卓
let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
export default {
  name: "Home",
  data() {
   return {
     isIOS:isIOS,
      commonInfo: [
        {
          name: "极光推送 - JPush SDK",
          company: "深圳市和讯华谷信息技术有限公司",
          goal: "为 APP 用户提供信息推送服务",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID、Boot ID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、DHCP、WIFI状态信息）、推送信息日志：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识，保证服务在不同设备上的兼容性和准确识别，同时了解推送信息送达的情况。设备标识符（包括IMEI、MAC、IMSI）：可选个人信息，用于推送服务基本业务功能场景中生成终端用户设备唯一标识的补充，提升唯一设备标识的准确性，进而提升推送的精确度和触达率；网络信息（包括SSID、BSSID、WIFI列表信息、基站信息、SIM卡状态）：可选个人信息，用于推送服务基本业务功能场景中判定模糊位置信息，选择就近推送服务节点提供推送服务，提升推送触达率。位置相关信息：地理围栏、用户分群推送、用户洞察扩展功能所必要个人信息，用于提供线下场景的精细化推送，根据位置信息推荐更符合您需要的推送内容；软件列表信息（包括软件列表及软件运行列表信息）：用户分群、应用自启动、链路调节器、用户洞察扩展功能所必要个人信息：有助于帮助您洞察您终端用户的兴趣偏好，帮助您为用户提供更合适的推送内容，同时优化SDK长连接稳定性，提升推送送达率及应用活跃度及通过合并链路，达到为用户省电省流量的目的。",
          link: "https://www.jiguang.cn/license/privacy",
        },
       {
          name: "友盟+移动统计SDK",
          company: "友盟同欣（北京）科技有限公司",
          goal: "进行APP数据统计分析",
          type: "调用系统相关接口自动采集",
          range:"设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID ; 可选-IMEI/IMSI/ICCID）、 网络信息、位置信息（可选）、应用列表（可选）",
          link:"https://www.umeng.com/page/policy"
        }, 
        {
          name: "友盟+社会化分享SDK",
          company: "友盟同欣（北京）科技有限公司",
          goal: "提供APP信息分享服务",
          type: "调用系统相关接口自动采集",
          range: "设备信息（Android ID/IDFA/IDFV/OAID/OpenUDID/GUID；可选-IMEI/IMSI/ICCID）、网络信息、应用列表（可选）",
          link: "https://www.umeng.com/page/policy"
        },
        {
          name: "微信Open SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "微信账号登录、微信支付、微信分享",
          type: "调用系统相关接口自动采集",
          range: "分享的图片和内容、主动选择的微信头像和昵称、微信支付订单标识",
          link: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8#__section1"
        },
        {
          name: "QQ互联SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "QQ账号登录、QQ分享",
          type: "调用系统相关接口自动采集",
          range: "分享的图片和内容、主动选择的QQ头像和昵称",
          link: "https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e"
        },
         {
          name: "高德地图、定位SDK",
          company: "高德软件有限公司",
          goal: "用于提供定位和地图功能",
          type: "调用系统相关接口自动采集",
          range: "应用名和版本号、设备品牌型号、操作系统、运营商基站和信号信息、传感器信息、IP地址、设备网络硬件地址（MAC）、蓝牙信息、WiFi状态和SSID和附近WiFi列表、电话信息、定位经纬度（含后台定位）、标识符OAID、GAID",
          link: "https://lbs.amap.com/home/privacy/"
        }
      ],
      isAndroidInfo:[
         {
          name: "Bugly SDK",
          company: "深圳市腾讯计算机系统有限公司",
          goal: "排查质量问题,帮助APP提升运行质量",
          type: "调用系统相关接口自动采集",
          range: "手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID",
          link: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
        },
        {
          name: "支付宝支付客户端SDK",
          company: "支付宝(杭州)信息技术有限公司",
          goal: "开通付费会员的支付",
          type: "调用系统相关接口自动采集",
          range: "设备状态权限、网络连接权限",
          link: "https://opendocs.alipay.com/isv/03l221"
        },
        {
          name: "华为推送SDK",
          company: "华为软件技术有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "应用信息（应用基本信息），设备信息（AAID、设备标识符、设备硬件信息、系统基本信息、系统设置）",
          link: "https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/sdk-data-security-0000001050042177"
        },
        {
          name: "小米推送SDK",
          company: "北京小米移动软件有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型、WiFi状态",
          link: "https://dev.mi.com/console/doc/detail?pId=1822"
        },
        {
          name: "vivo PUSH - SDK消息推送",
          company: "维沃移动通信有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android ID）、使用推送服务的应用软件信息（如应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络相关信息（如IP地址、网络类型）、国家码、设备类型；推送SDK版本号、设备型号、操作系统版本、当前网络类型、消息发送结果、通知栏状态（如通知栏权限、用户点击行为）、锁屏状态（如是否锁屏，是否允许锁屏通知）",
          link: "https://dev.vivo.com.cn/documentCenter/doc/652#"
        },
        {
          name: "OPPO PUSH客户端SDK",
          company: "广东欢太科技有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "RegisterId、appKey、MCS应用包名、版本号、推送SDK版本号",
          link: "https://open.oppomobile.com/new/developmentDoc/info?id=11228"
        },
        {
          name: "荣耀推送SDK",
          company: "深圳荣耀软件技术有限公司",
          goal: "推送消息通知",
          type: "调用系统相关接口自动采集",
          range: "设备标识符（AAID、PushToken）、APPID、应用包名",
          link: "https://developer.honor.com/cn/docs/11002/guides/sdk-data-security"
        },
        {
          name: "移动智能终端补充设备标识体系统一调用 SDK",
          company: "中国信息通信研究院",
          goal: "生成设备唯一标识符",
          type: "调用系统相关接口自动采集",
          range: "设备制造商、设备型号、设备品牌、设备网络运营商名称、App 包名及签名信息，或在对应应用商店的 APPID、开放匿名设备标识符(OAID)、开发者匿名设备标识符(VAID)、应用匿名设备标识符(AAID)",
          link: "https://www.msa-alliance.cn/col.jsp?id=122"
        },
        {
          name: "360加固SDK",
          company: "北京鸿享技术服务有限公司",
          goal: "用于检测App故障和诊断,App安全加固保护,盗版检测服务,威胁环境检测服务,以便帮助用户快速解决异常情况",
          type: "调用系统相关接口自动采集",
          range:
            "设备标识符（Android ID、OAID）",
          link: "https://jiagu.360.cn/#/global/help/322",
        }
      ]
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}
.hello{
  margin:20px;
}

h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px;
}

li {
  margin: 10px 0;
  list-style: none;
}

p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
.warn{
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue